import axios from 'axios';

export default {
  install(app, options) {
    let csrfToken = options?.csrfToken;
    let baseHost = window.location.protocol + '//' + window.location.host;
    let findStaffUrl = baseHost + '/api/staff/search';

    // Use new Vue instance as an event bus
    const staffservice = {}; //new Vue();
    // Every component will use this.$stops to access the event bus
    app.config.globalProperties.$staffservice = staffservice;

    staffservice.setCsrfToken = (token) => {
      csrfToken = token;
    };

    staffservice.findStaff = (query, units, departments) => {
      axios.defaults.headers.get['X-XSRF-Token'] = csrfToken;
      var response = axios.get(findStaffUrl + '?q=' + query + '&u=' + units + '&d=' + departments);
      return response;
    };
  },
};
